import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare, UserMinus } from 'lucide-react';
import Layout from '../components/Layout';
import { connectionsAPI } from '../api/client';
import '../styles/friends.css';

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  return (parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : name[0]).toUpperCase();
}

export default function Friends() {
  const navigate = useNavigate();
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentUserId = localStorage.getItem('userId');

  const load = async () => {
    try {
      const res = await connectionsAPI.getAll();
      setConnections(res.data || []);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const accepted  = connections.filter(c => c.status === 'accepted');
  const incoming  = connections.filter(c => c.status === 'pending' && c.connected_user_id === currentUserId);
  const outgoing  = connections.filter(c => c.status === 'pending' && c.user_id === currentUserId);

  const handleRemove = async (id) => {
    if (!window.confirm('Remove this friend?')) return;
    try { await connectionsAPI.delete(id); load(); } catch {}
  };

  const handleCancel = async (id) => {
    try { await connectionsAPI.delete(id); load(); } catch {}
  };

  const handleAccept = async (id) => {
    try { await connectionsAPI.accept(id); load(); } catch {}
  };

  return (
    <Layout title="Friends">
      <div className="friends-page">
        <div className="friends-header">
          <h1 className="friends-title">Friends</h1>
          <button className="friends-add-btn" onClick={() => navigate('/find-friends')}>+ Add friends</button>
        </div>

        {incoming.length > 0 && (
          <section className="friends-section">
            <h2 className="friends-section-title">Requests ({incoming.length})</h2>
            {incoming.map(c => (
              <div key={c.id} className="friends-row">
                <div className="friends-avatar">{getInitials(c.display_name)}</div>
                <div className="friends-info">
                  <span className="friends-name">{c.display_name || c.phone_email}</span>
                  <span className="friends-sub">Wants to connect</span>
                </div>
                <div className="friends-actions">
                  <button className="friends-accept-btn" onClick={() => handleAccept(c.id)}>Accept</button>
                  <button className="friends-decline-btn" onClick={() => handleRemove(c.id)}>Decline</button>
                </div>
              </div>
            ))}
          </section>
        )}

        {outgoing.length > 0 && (
          <section className="friends-section">
            <h2 className="friends-section-title">Sent ({outgoing.length})</h2>
            {outgoing.map(c => (
              <div key={c.id} className="friends-row">
                <div className="friends-avatar">{getInitials(c.display_name)}</div>
                <div className="friends-info">
                  <span className="friends-name">{c.display_name || c.phone_email}</span>
                  <span className="friends-sub">Request pending</span>
                </div>
                <div className="friends-actions">
                  <button className="friends-decline-btn" onClick={() => handleCancel(c.id)}>Cancel</button>
                </div>
              </div>
            ))}
          </section>
        )}

        <section className="friends-section">
          <h2 className="friends-section-title">
            {accepted.length > 0 ? `All friends (${accepted.length})` : 'Friends'}
          </h2>
          {loading ? (
            <p className="friends-empty">Loading…</p>
          ) : accepted.length === 0 ? (
            <div className="friends-empty-state">
              <p>No friends yet.</p>
              <button className="friends-find-btn" onClick={() => navigate('/find-friends')}>
                Find people you know →
              </button>
            </div>
          ) : (
            accepted.map(c => {
              const friendId = c.user_id === currentUserId ? c.connected_user_id : c.user_id;
              return (
              <div key={c.id} className="friends-row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/profile/${friendId}`)}>
                <div className="friends-avatar">{getInitials(c.display_name)}</div>
                <div className="friends-info">
                  <span className="friends-name">{c.display_name || c.phone_email}</span>
                </div>
                <div className="friends-actions" onClick={e => e.stopPropagation()}>
                  <button className="friends-msg-btn" onClick={() => navigate(`/messages/${friendId}`)}>
                    <MessageSquare size={14} /> Message
                  </button>
                  <button className="friends-remove-btn" onClick={() => handleRemove(c.id)}>
                    <UserMinus size={14} />
                  </button>
                </div>
              </div>
              );
            })
          )}
        </section>
      </div>
    </Layout>
  );
}
